import React from 'react';
import {Accounts} from '../Accounts';
import {useHistory, useLocation, useRouteMatch} from 'react-router-dom';

export const MasterAccountAccounts: React.FC<any> = ({masterAccountId}) => {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();

  return (
    <Accounts
      history={history}
      location={location}
      match={match}
      masterAccountId={masterAccountId}
    />
  );
};
